// Saltos a secciones (#oferta, #coleccion...). Las fotos con carga diferida que están arriba
// miden 0 px hasta cargar y empujan la sección hacia abajo después del salto, así que:
// se fuerza la carga de esas fotos y se corrige la posición mientras la página se acomoda.
export function initAnchorScroll(root: HTMLElement): () => void {
  let timers: number[] = [];
  let stopAt = 0;

  const headerHeight = () => {
    const h = document.querySelector("header") as HTMLElement | null;
    return h ? h.offsetHeight : 0;
  };

  const targetTop = (el: HTMLElement) =>
    el.getBoundingClientRect().top + window.scrollY - headerHeight();

  const clear = () => {
    timers.forEach((t) => window.clearTimeout(t));
    timers = [];
  };

  const onClick = (e: MouseEvent) => {
    const a = (e.target as HTMLElement | null)?.closest?.('a[href^="#"]') as HTMLAnchorElement | null;
    if (!a) return;
    const id = a.getAttribute("href")!.slice(1);
    const el = id ? document.getElementById(id) : null;
    if (!el) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    clear();

    const imgs = Array.from(document.images).filter((i) => i.loading === "lazy");
    imgs.forEach((i) => (i.loading = "eager"));

    window.scrollTo({ top: targetTop(el), behavior: "auto" });
    stopAt = Date.now() + 2500;

    const fix = () => {
      if (Date.now() > stopAt) return;
      const top = targetTop(el);
      if (Math.abs(window.scrollY - top) > 4) window.scrollTo({ top, behavior: "auto" });
    };
    imgs.forEach((i) => i.complete || i.addEventListener("load", fix, { once: true }));
    [100, 400, 900, 1600, 2500].forEach((ms) => timers.push(window.setTimeout(fix, ms)));
    // Si la persona scrollea a mano, se deja de corregir
    const cancel = () => {
      stopAt = 0;
      clear();
    };
    window.addEventListener("wheel", cancel, { once: true, passive: true });
    window.addEventListener("touchstart", cancel, { once: true, passive: true });
    history.replaceState(null, "", "#" + id);
  };

  root.addEventListener("click", onClick, true);
  return () => {
    clear();
    root.removeEventListener("click", onClick, true);
  };
}
